// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"CoursesAndTrainings_buttonsContainer__2OAEI","buttonsDescription":"CoursesAndTrainings_buttonsDescription__1zRJk","button":"CoursesAndTrainings_button__3157r"};